import Joi from "joi";

import {moduleNamespace} from './constants';
import {writeSession} from '../sharedGlobal';

export function getOperationCountrySchema(countries) {
  return Joi.string()
    .label('Operation country')
    .required()
    .valid(...Object.values(countries))
    .messages({
      'any.only': 'Invalid country selected',
    });
}

export function writeConfigurationToSession(configuration) {
  writeSession(moduleNamespace, 'configuration', JSON.stringify(configuration));
}
